import { storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc';

const colClasses = {
  '1': 'grid-cols-1',
  '2': 'grid-cols-1 sm:grid-cols-2',
  '3': 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3',
  '4': 'grid-cols-1 sm:grid-cols-2 md:grid-cols-4',
  // 6 is for dense rows of small items (logo strips, icon rows). It starts at 2
  // rather than 1 because six full-width items would be an absurd mobile column.
  '6': 'grid-cols-2 sm:grid-cols-3 md:grid-cols-6',
};

// The card a grid item holds: the item itself, or a card wrapped in a box
// (e.g. a box that only adds a positioned badge).
const cardIn = (item) =>
  item?.component === 'card' ? item : item?.body?.find((b) => b.component === 'card');

// How many parts a card stacks — the rows each card spans when the grid lines
// card rows up (see .cms-grid-rows in app/styles/grid.css). Absolutely
// positioned blocks take no row.
const cardRows = (card) =>
  [card.badge, card.icon, card.title, card.description, card.cta_text].filter(Boolean).length +
  (card.body || []).filter((b) => !b.position_absolute).length;

const Grid = ({ blok }) => {
  const cols = colClasses[blok.columns] || colClasses['1'];
  const gap = blok.gap || 'gap-4';
  const align = blok.align_items || 'items-start';
  const justify = blok.justify_items || '';
  const maxWidth = blok.max_width || '';
  const mx = maxWidth ? 'mx-auto' : '';
  // Phones stack the items; this lifts the last one to the top, so a text-then-
  // image row still opens with its image there, as the old site's feature rows did.
  const lastFirst = blok.last_first_on_mobile ? 'max-sm:[&>*:last-child]:order-first' : '';
  const rows = blok.align_card_rows
    ? Math.max(0, ...(blok.items || []).map(cardIn).filter(Boolean).map(cardRows))
    : 0;

  return (
    <div
      {...storyblokEditable(blok)}
      className={`grid ${cols} ${gap} ${align} ${justify} ${maxWidth} ${mx} ${lastFirst} ${rows ? 'cms-grid-rows' : ''}`.replace(/\s+/g, ' ').trim()}
      style={rows ? { '--card-rows': rows } : undefined}
    >
      {blok.items?.map((nestedBlok) => (
        <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </div>
  );
};

export default Grid;
